module.exports = __webpack_public_path__ + "static/media/1022825.ef35eea3.jpg";